import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

/**
 * @description base class including button text modifications logic
 */
export abstract class ButtonTextBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].TEXT;
  }
}
